<app-page-header
  [title]="'Noticias'"
  [breadcrumbs]="breadcrumbs"
  [backgroundImage]="'headers/Noticias.png'"
></app-page-header>

<div class="
  w-full 
  3xl:px-[295px] 2xl:px-[120px] xl:px-[45px] px-4
  lg:py-10 md:py-10 
">
  <!-- Loading Overlay -->
  @if (isLoading()) {
    <div class="fixed inset-0 bg-black/20 backdrop-blur-xs z-40 flex items-center justify-center transition-opacity duration-300">
      <div class="bg-transparent rounded-full">
        <div class="w-12 h-12 border-4 border-secondary border-t-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  }
  
  <div class="grid grid-cols-1 md:grid-cols-10">
    <!-- sidebar (izquierda en desktop, debajo del listado en móvil) -->
    <div class="order-2 md:order-1 md:col-span-3">
      <div class="pe-0 md:pe-[25px]">
        <app-news-sidebar [showRecentPosts]="false"></app-news-sidebar>
      </div>
    </div>

    <div class="order-1 md:order-2 md:col-span-7">
      <div
        class="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6 auto-rows-fr transition-opacity duration-300"
        [class.opacity-50]="isLoading()"
        [class.opacity-100]="!isLoading()"
      >
        @for (post of posts(); track post.id) {
          <app-blog-item [post]="post" [index]="$index + 1"></app-blog-item>
        }
      </div>
      <!-- Pagination -->
      <div class="flex justify-center gap-4 mt-10 mb-5">
    @if(currentPage() > 1) {
      <button
        (click)="goToPage(currentPage() - 1)"
        [disabled]="isLoading()"
        class="w-12 h-12 border border-border-2 rounded-full font-semibold text-heading-primary hover:bg-secondary hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span class="material-symbols-outlined">
          keyboard_arrow_left
        </span>
      </button>
    }
    
    @for (pageNum of [].constructor(totalPages()); track $index) {
      <button 
        (click)="goToPage($index + 1)"
        [disabled]="isLoading()"
        [class]="'w-12 h-12 border border-border-2 rounded-full font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ' + 
                 (currentPage() === $index + 1 ? 'bg-secondary text-white' : 'text-heading-primary hover:bg-secondary hover:text-white')"
      >
        {{ $index + 1 }}
      </button>
    }
    
    @if(currentPage() < totalPages()) {
      <button
        (click)="goToPage(currentPage() + 1)"
        [disabled]="isLoading()"
        class="w-12 h-12 border border-border-2 rounded-full font-semibold text-heading-primary hover:bg-secondary hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span class="material-symbols-outlined">
          keyboard_arrow_right
        </span>
      </button>
    }
      </div>
    </div>
  </div>
</div>